import { gql } from "@apollo/client";
import {TypeDefinitionAttributeFields} from "../fragments/typeDefinitionAttribute";

export const InstalledBaseAccessGroupListTdas = gql`
    query InstalledBaseAccessGroupListTdas ($tdaActionKey: InstalledBaseAccessGroupTypeDefinitionIndex) {
        installedBaseAccessGroupList {
            typeDefinitionAttributeList (typeDefinitionIndex: $tdaActionKey) {
                total
                typeDefinitionAttributes {
                    ...TypeDefinitionAttributeFields
                }
            }
        }
    }
    ${TypeDefinitionAttributeFields}
`;
